/** Ticket 78637 — Wendolyne Nahomy Aguilar, vista Horas observación sin abrir el puesto 31 a todos. */
export const IDERPS_HORAS_OBSERVACION = [2594]

function menuTienePath(menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    for (const cat of top.items || []) {
      if (cat && cat.path === path) return true
      for (const child of cat.items || []) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

function inyectarJuntoARolClases(list, action) {
  for (const top of list) {
    if (!Array.isArray(top.items)) continue
    for (let i = 0; i < top.items.length; i++) {
      const cat = top.items[i]
      if (cat && cat.path === 'RolClases' && !cat.items) {
        top.items.splice(i + 1, 0, action)
        return true
      }
      if (cat && Array.isArray(cat.items)) {
        for (let j = 0; j < cat.items.length; j++) {
          if (cat.items[j] && cat.items[j].path === 'RolClases') {
            cat.items.splice(j + 1, 0, action)
            return true
          }
        }
      }
    }
  }
  return false
}

export function asegurarMenuHorasObservacion(menu, iderp) {
  if (!IDERPS_HORAS_OBSERVACION.includes(Number(iderp))) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  const path = 'HorasObservacion'
  if (menuTienePath(list, path)) return list

  const action = {
    title: 'Horas Observacion',
    path,
    icon: 'mdi-eye-outline',
    active: 0,
  }

  if (inyectarJuntoARolClases(list, action)) return list

  let academico = list.find((m) => {
    const t = String((m && m.title) || '').toLowerCase()
    return t.includes('acad')
  })
  if (!academico) {
    academico = { title: 'Académico', items: [] }
    list.push(academico)
  }
  if (!Array.isArray(academico.items)) academico.items = []
  academico.items.push(action)
  return list
}

export function tieneAccesoHorasObservacionIderp(iderp) {
  return IDERPS_HORAS_OBSERVACION.includes(Number(iderp))
}
